import { fetchAction, createInsecureHash } from "../../utilities"; 
import { Filter } from 'bad-words'

/**
 * templateForm - Alpine Component
 * 
 * @module alpine/design-huddle/templateForm
 * @requires alpine
 */
export const designHuddleForm = (csrfToken, cmsTemplates, badWords, goodWords, turnstileKey) => ({
    tco: {},
    loading: true,
    currentImg: '',
    errorString: '',
    template: null,
    cmsTemplates: cmsTemplates,
    csrfToken: csrfToken,
    badWords: badWords,
    goodWords: goodWords,
    turnstileKey: turnstileKey,
    inputs: [],
    getTemplateInfo: getTemplateInfo,
    initiateStickerExport: initiateStickerExport,
    pollStickerExportProgress: pollStickerExportProgress,
    getSmartPreview: getSmartPreview,
    goToEmbed: goToEmbed,
    validateDesignHuddleForm: validateDesignHuddleForm
})

/**
 * Intiates a sticker export for design huddle
 */
async function initiateStickerExport() {

    // Setup Constants
    const alpine = this
    const form = this.$refs.form
    const formData = new FormData(form)
    const requestUrl = "/actions/design-huddle/sticker-export/get-export"

    let validate = alpine.validateDesignHuddleForm(formData)

    if (!validate) {
        alpine.loading = false
        return
    }

    // Setup variables for request body
    let tco = {customizations: { classes: {}}}
    let formDataString = ""

    alpine.loading = true

    // Add input values to body
    for (const [key, value] of formData) {
        formDataString = formDataString + value
        tco.customizations.classes[key] = {
            text: value,
            auto_fit: true
        }
    }
    // Turn form values into a unique hash
    let filenameHash = createInsecureHash(formDataString)

    // Setup body for request
    const body = JSON.stringify({
        customizations: tco,
        templateID: alpine.template.template_id,
        filename: filenameHash
    })

    const response = await fetchAction(requestUrl, "POST", this.csrfToken, body)

    
    if (response.isSuccessful && response.successData.success) {

        let data    = response.successData.data
        let job_id  = data.job_id

        this.pollStickerExportProgress(job_id, 1)

    } else {
        alpine.loading = false
        console.error("Failed to submit sticker:", error)
    }

}


/**
 * Polls the progress of the sticker being exported from designHuddle
 * @param {string} jobId - design huddle job passed in from initiateStickerExport
 * @param {num} attempt - attempts taken at polling, auto-sets to 1 initially
 */
async function pollStickerExportProgress(jobId, attempt) {

    const alpine = this
    attempt = attempt || 1

    const requestUrl = "/actions/design-huddle/sticker-export/poll-export-job"
    const body = JSON.stringify({jobId: jobId})

    const request = await fetchAction(requestUrl, "POST", this.csrfToken, body)

    if (request.isSuccessful) {

        let success = request.successData.success
        let data = request.successData.data

        let completed = !success || !data || (data.completed && attempt < 10)

        if (!completed) {

            setTimeout( () => {
                alpine.pollStickerExportProgress(jobId, attempt + 1)
            }, attempt * 1000) 
            
        } else {

            if (data.completed) {

     
                let imageBody = JSON.stringify({imageUrl: data.download_url})

                const image_url = await fetchAction("/actions/design-huddle/sticker-export/download-and-save-image", "POST", this.csrfToken, imageBody)

                alpine.loading = false
                alpine.goToEmbed(image_url.successData.url)

            } else {

                new Error("Export Job Timeout");
                alpine.loading = false

            }
        }

    } else {
        console.error("Failed to poll job: ", request.errorData);
    }

}


/**
 * getSmartPreview
 * Uses design huddles SDK to generate a preview image for sticker
 * 
 * @see {@link https://api.designhuddle.com/jssdk#/DSHDLib.TemplateCustomizationObjects.html} for info on tco object
 * @see {@link https://api.designhuddle.com/jssdk#/DSHDLib.html#.configure} for DSHDLib.configure()
 * @see {@link https://api.designhuddle.com/jssdk#/DSHDLib.html#.getVariableTemplatePreviewURL} for DSHDLib.getVariableTemplatePreviewURL()
 */
async function getSmartPreview() {
        
    const form = this.$refs.form
    const formData = new FormData(form)
    const alpine = this

    alpine.loading = true

    let tco = {classes: {}}

    console.log("test")

    let validate = await alpine.validateDesignHuddleForm(formData, false)

    console.log(validate)

    if (!validate) {
        alpine.loading = false
        return
    }

    for (const [key, value] of formData) {
        tco.classes[key] = {
            "auto_fit": true,
            "text": value
        }
    }

    DSHDLib.configure({
        domain: "titos.designhuddle.com",
        client_id: "qfvuxxvot37vhjvxvku7",
        template_customization_object: tco,
        visitor: true
    })

    DSHDLib.getVariableTemplatePreviewURL(
        { template_code: alpine.template.template_code, customizations: tco, width: 400 },
        function (err, url) {
            if (err) {
                console.log("Error getting preview URL:", err);
                alpine.loading = false
                return;
            }

            let newImage = new Image()
            newImage.onload = () => {
                alpine.currentImg = url;
                alpine.loading = false;
            }
            newImage.src = url
        }
    )
}

/**
 * dispatches even to change to final page with url
 * @param {string} url 
 */
function goToEmbed(url) {
    this.$dispatch('dh:export-complete', {url: url})
    this.$dispatch('dh:change-page', {page: 'sweepstakesForm'})
}

/**
 * Catches template after template selection
 */
function getTemplateInfo(template, turnstileKey) {
    const alpine = this
    
    this.template = template
    this.currentImg = template.preview_url
    this.inputs =  this.cmsTemplates[template.template_code].inputs

    let dummyImg = new Image()
    dummyImg.onload = () => {
        alpine.loading = false
    }
    dummyImg.src = this.currentImg

    this.widgetId = turnstile.render(alpine.$refs.form, {
        sitekey:  turnstileKey,
        appearance: 'interaction-only',
    });
    
}

/**
 * validates form
 */
async function validateDesignHuddleForm(formData, turnstileValidation = true) {
    const alpine = this
    const filter = new Filter()
    const extraBadWords = this.badWords.split(',')
    const goodWords = this.goodWords.split(',')
    filter.addWords(...extraBadWords)
    filter.removeWords(...goodWords)

    for (const [key, value] of formData) {
        
        if (key == 'emailAddress' && value) {
            return false
        }

        if (key == 'cf-turnstile-response' && turnstileValidation) {
            const turnstileValid = await fetchAction(
                '/actions/design-huddle/sticker-export/validate-turnstile-token', 
                'POST',
                alpine.csrfToken,
                JSON.stringify({token: value})
            )

            if (!turnstileValid.successData.data.success) {
                console.error('Turnstile is not valid');
                return false
            }
        }

        ['cf-turnstile-response', 'emailAddress'].includes(key)

        if ( !['cf-turnstile-response', 'emailAddress'].includes(key) ) {
            let input = Object.entries(alpine.inputs).find(([objKey, obj]) => obj.value === key)

            let alpineInput = alpine.inputs[input[0]]
            let cleanedInput = filter.clean(value)

            if (cleanedInput !== value) {
                alpineInput.error = "Your input contains language that isn't allowed. Please revise and try again."
                return false
            }

            alpineInput.error = null
        }
    }

    return true
}